import { AuthLayout, ModalLayout } from "shared";
import { clearLocalStorage } from "utils";
import { FormFeedback } from "reactstrap";
import { useAuthenticate } from "master/hooks";
import maratiLogo from "assets/images/marati_logo.png";
import SimpleReactValidator from "simple-react-validator";
import InputControl from "shared/components/InputControl";
import React, { useEffect, useRef, useState } from "react";
import loginPageGraphics from "assets/images/login.png";
import warningIcon from "assets/images/warning-graphics.svg";

export const LoginMWCD = () => {
  const {
    authenticateState,
    setAuthenticateState,
    isUserEmailExist,
    authenticateUser,
    modalState,
    onCloseModal,
  } = useAuthenticate();
  const { credential } = authenticateState;
  const [isErrorShown, setIsErrorShown] = useState(false);
  const { userName } = credential;
  const [update, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    })
  );

  const onHandleChange = (e) => {
    const { value } = e.target;
    setAuthenticateState((draft) => {
      draft.isInValidPassword = false;
      draft.credential.userName = value;
      draft.credential.password = value;
    });
    setIsErrorShown(false);
    validator.current.hideMessages();
  };

  useEffect(() => {
    sessionStorage.clear();
    clearLocalStorage();
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    if (
      credential.userName &&
      !/[^0-9]/.test(credential.userName) &&
      credential.userName.length === 10
    ) {
      authenticateUser.mutate(credential);
      validator.current.hideMessages();
    } else {
      validator.current.showMessages();
      forceUpdate((prev) => prev + 1);
    }
  };

  return (
    <>
      <AuthLayout leftDivImage={loginPageGraphics}>
        <form>
          <h2 className="lh-2">एनर्जी विद्या मध्ये आपले स्वागत आहे.</h2>
          <div className="mb-3">
            <label className="form-label">फोन नंबर</label>
            <InputControl
              type="text"
              name="userName"
              value={userName}
              className="form-control"
              onChange={onHandleChange}
              autoComplete="username"
              disabled={isUserEmailExist.isPending}
              invalid={validator.current.message(
                "Email Address",
                userName,
                "required|email"
              )}
            />
            {(isErrorShown || validator.current.messagesShown) && (
              <FormFeedback>
                {!userName
                  ? "मोबाईल नंबर आवश्यक आहे"
                  : /[^0-9]/.test(userName)
                  ? "मोबाईल नंबर फॉरमॅट चुकीचा आहे."
                  : userName.length !== 10 && "१० अंकी मोबाईल नंबर एंटर करा."}
              </FormFeedback>
            )}
          </div>
          <button
            type="submit"
            onClick={(e) => onSubmit(e)}
            className="btn btn-primary"
            disabled={isUserEmailExist.isPending}
          >
            पुढे जा
          </button>
        </form>
        <div className="login-mwcd-logo">
          <img src={maratiLogo} alt="" />
        </div>

        {modalState.actionFrom === "invalidPassword" && modalState.isOpen && (
          <ModalLayout
            isOpen={modalState.isOpen}
            title={"आमच्या सिस्टममध्ये तो मोबाईल नंबर सापडला नाही."}
            message={
              "तुम्ही दिलेला मोबाईल नंबर आमच्या रेकॉर्डशी जुळत नाही. कृपया तपशील तपासा आणि पुन्हा प्रयत्न करा."
            }
            onConfirm={onCloseModal}
            onCancel={onCloseModal}
            confirmButtonLabel={"पुन्हा प्रयत्न करा"}
            icon={warningIcon}
          />
        )}
      </AuthLayout>
    </>
  );
};
